"use strict";
exports.__esModule = true;
exports.SymbolCollectionAssetBuilder = exports.SymbolCollectionAsset = void 0;
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var SymbolCollectionAsset = /** @class */ (function () {
    function SymbolCollectionAsset() {
    }
    SymbolCollectionAsset.getSymbolCollections = function (symbolCollectionAssets) {
        return symbolCollectionAssets.map(function (asset) {
            var symbolCollection = {
                id: asset.id,
                title: asset.title,
                description: asset.description,
                symbols: asset.symbols
            };
            return symbolCollection;
        });
    };
    return SymbolCollectionAsset;
}());
exports.SymbolCollectionAsset = SymbolCollectionAsset;
var SymbolCollectionAssetBuilder = /** @class */ (function () {
    function SymbolCollectionAssetBuilder(symbolCollectionAsset) {
        this.symbolCollectionAsset = symbolCollectionAsset;
    }
    SymbolCollectionAssetBuilder.initialiseWithSymbolCollectionAsset = function (symbolCollectionAsset) {
        return new SymbolCollectionAssetBuilder(symbolCollectionAsset);
    };
    SymbolCollectionAssetBuilder.initialiseWithSymbolCollection = function (ownerPartyId, sharedWithEveryone, symbolCollection) {
        return SymbolCollectionAssetBuilder.initialiseWithSymbolCollectionAsset({
            id: symbolCollection.id,
            ownerPartyId: ownerPartyId,
            public: sharedWithEveryone,
            title: symbolCollection.title,
            description: symbolCollection.description,
            symbols: symbolCollection.symbols,
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    SymbolCollectionAssetBuilder.initialise = function (ownerPartyId, sharedWithEveryone, title, description) {
        return SymbolCollectionAssetBuilder.initialiseWithSymbolCollectionAsset({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            ownerPartyId: ownerPartyId,
            public: sharedWithEveryone,
            title: title,
            description: description,
            symbols: [],
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    SymbolCollectionAssetBuilder.prototype.hasSymbol = function (symbolId) {
        return this.symbolCollectionAsset.symbols.includes(symbolId);
    };
    SymbolCollectionAssetBuilder.prototype.addSymbol = function (symbolId) {
        this.symbolCollectionAsset.symbols = Array.from((new Set(this.symbolCollectionAsset.symbols)).add(symbolId));
        return this;
    };
    SymbolCollectionAssetBuilder.prototype.removeSymbol = function (symbolId) {
        var theSet = new Set(this.symbolCollectionAsset.symbols);
        theSet["delete"](symbolId);
        this.symbolCollectionAsset.symbols = Array.from(theSet);
        return this;
    };
    SymbolCollectionAssetBuilder.prototype.withId = function (id) {
        this.symbolCollectionAsset.id = id;
        return this;
    };
    SymbolCollectionAssetBuilder.prototype.getId = function () {
        return this.symbolCollectionAsset.id;
    };
    SymbolCollectionAssetBuilder.prototype.build = function () {
        return this.symbolCollectionAsset;
    };
    SymbolCollectionAssetBuilder.prototype.buildUpdate = function () {
        return {
            ownerPartyId: this.symbolCollectionAsset.ownerPartyId,
            public: this.symbolCollectionAsset.public,
            title: this.symbolCollectionAsset.title,
            description: this.symbolCollectionAsset.description,
            symbols: this.symbolCollectionAsset.symbols
        };
    };
    SymbolCollectionAssetBuilder.prototype.withSymbolCollectionUpdate = function (symbolCollectionUpdate) {
        this.symbolCollectionAsset = {
            id: this.symbolCollectionAsset.id,
            ownerPartyId: this.symbolCollectionAsset.ownerPartyId,
            public: this.symbolCollectionAsset.public,
            title: (symbolCollectionUpdate.title) ? symbolCollectionUpdate.title : this.symbolCollectionAsset.title,
            description: (symbolCollectionUpdate.description) ? symbolCollectionUpdate.description : this.symbolCollectionAsset.description,
            symbols: (symbolCollectionUpdate.symbols) ? symbolCollectionUpdate.symbols : this.symbolCollectionAsset.symbols,
            createdAt: this.symbolCollectionAsset.createdAt,
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        };
        return this;
    };
    return SymbolCollectionAssetBuilder;
}());
exports.SymbolCollectionAssetBuilder = SymbolCollectionAssetBuilder;
